<div class="fullscreen-inner">
  <div class="fullscreen-header">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="fullscreen-body">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="fullscreen-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>